import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import AppContext from '../../AppContext';
import { getPosts } from '../../../api/posts';
import Spinner from '../../shared/Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faStar } from '@fortawesome/free-solid-svg-icons';

const sortByTitle = (a, b) =>
  a.title.localeCompare(b.title, undefined, {
    ignorePunctuation: true,
  });
const sortByPostCount = (a, b) => {
  const countA = a.posts?.length || 0;
  const countB = b.posts?.length || 0;
  if (countA !== countB) return countB - countA;
  return a.title.localeCompare(b.title, undefined, { ignorePunctuation: true });
};
const sortByUrl = (a, b) => a.url.localeCompare(b.url);

const getDisplayName = (room) => {
  const nameMap = {
    bookclub: 'Book Club',
    dev: 'Dev',
    general: 'General',
    healthyrelating: 'Healthy Relating',
    home: 'Home',
    parenting: 'Parenting',
    productivity: 'Productivity',
    selfwork: 'Self Work',
    writing: 'Writing',
  };
  return nameMap[room.id] || room.title;
};

const getRoomUrl = (room) => {
  if (room.id === 'home') return '/r/home';
  return room.url;
};

const Rooms = () => {
  const { rooms } = useContext(AppContext);
  const [sortFunction, setSortFunction] = useState(() => sortByPostCount);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPosts((posts) => {
      Object.entries(rooms).forEach(([key, room]) => {
        if (room.id === 'home') {
          rooms[key].posts = { length: Object.values(posts).length };
        } else {
          rooms[key].posts = Object.values(posts).filter(
            (post) => post.room === room.id
          );
        }
      });
      setLoading(false);
    });
  }, []);

  if (loading) return <Spinner />;

  return (
    <Card>
      <Card.Body>
        <Card.Title>Rooms</Card.Title>
        {rooms && (
          <Table hover>
            <thead>
              <tr>
                <th onClick={() => setSortFunction(() => sortByTitle)}>Name</th>
                <th onClick={() => setSortFunction(() => sortByUrl)}>URL</th>
                <th onClick={() => setSortFunction(() => sortByPostCount)}>
                  Post Count
                </th>
                <th>Access</th>
              </tr>
            </thead>
            <tbody>
              {Object.values(rooms)
                .sort(sortFunction)
                .map((room) => (
                  <tr key={room.id}>
                    <td>
                      <Link to={getRoomUrl(room)}>{getDisplayName(room)}</Link>
                    </td>
                    <td>
                      <Link
                        to={getRoomUrl(room)}
                        className="text-decoration-none"
                      >
                        <code
                          className="text-muted"
                          style={{ color: '#e83e8c' }}
                        >
                          {getRoomUrl(room)}
                        </code>
                      </Link>
                    </td>
                    <td>{room.posts?.length}</td>
                    <td>
                      {room.requires?.map((requirement, i, arr) => {
                        const elements = [];
                        if (requirement === 'premium') {
                          elements.push(
                            <Link
                              key={`link-${requirement}`}
                              to={'/premium'}
                              className="text-warning"
                            >
                              <FontAwesomeIcon icon={faStar} className="me-1" />
                              Premium Room
                            </Link>
                          );
                        } else {
                          elements.push(
                            <span
                              key={`text-${requirement}`}
                              className="text-muted"
                            >
                              <FontAwesomeIcon icon={faLock} className="me-1" />
                              {requirement}
                            </span>
                          );
                        }
                        if (i < arr.length - 1) {
                          elements.push(<span key={`comma-${i}`}>, </span>);
                        }
                        return elements;
                      })}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
};
export default Rooms;
